import React, {Fragment} from "react";
import Agreements from "../Agreements";
import CompanyInitialForm from "./CompanyInitialForm";
import withFormErrorHandler from "../withFormErrorHandler";
import PersonInitialForm from "./PersonInitialForm";

function StepForInitialData(props) {

    const agreementsChangeHandler = agreements => props.onChange({...props.offerWithCalculation, agreements: agreements});

    const onNextClickHandler = () => {
        props.onCheckErrorHandler(props.onNextClick);
    }

    let formFields = props.isCompany ? (<CompanyInitialForm {...props}/>) : (<PersonInitialForm {...props}/>);

    return (
        <Fragment>

            <div className="config-card-header">
                <div className="config-card-header-inner">
                    <p className="config-card-title">Wniosek online</p>
                </div>
            </div>
            <div className="config-card-body">
                <div className="cr-intro-grid">
                    <div className="cr-intro-list">
                        <p style={{margin: 0}}>Cieszymy się, że zainteresowałeś się naszą ofertą.<br/>
                            Teraz szybko, prosto, wygodnie i bezpiecznie:</p>
                        <div className="cr-intro-list-item">
                            <span className="cr-intro-icon">›</span>
                            <span><strong>zarezerwujesz</strong> na naszym stocku wybrany przez Ciebie samochód</span>
                        </div>
                        <div className="cr-intro-list-item">
                            <span className="cr-intro-icon">›</span>
                            <span><strong>złożysz wniosek</strong> leasingowy w 5 min.</span>
                        </div>
                        <div className="cr-intro-list-item">
                            <span className="cr-intro-icon">›</span>
                            <span><strong>otrzymasz wstępną decyzję leasingową</strong> w 10 s.</span>
                        </div>
                    </div>
                    <div className="cr-notice-box">
                        <span className="cr-notice-title">PAMIĘTAJ:</span>
                        <p className="cr-notice-body">Do momentu zawarcia umowy możesz zrezygnować z rezerwacji samochodu i dalszych działań.</p>
                    </div>
                </div>

                <form>
                    <div className="cr-form-grid cr-form-grid--3col">
                        {formFields}
                        <div className="cr-field-full">
                            <Agreements
                                onChange={agreementsChangeHandler}
                                formValidation={props.formValidator}
                                checkedAgreements={props.checkedAgreements}
                                hiddenAgreements={[1]}
                            />
                        </div>
                    </div>
                </form>
                <div className="config-modal-footer">
                    <div className="flex">
                        <button type="button" className="lastButton" onClick={onNextClickHandler}>Dalej <i className="fa fa-angle-right"></i></button>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}

export default withFormErrorHandler(StepForInitialData);